import React, { Suspense, useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import userStore from "../zustand/userStore";
import { logout } from "../auth/authSlice";
import { getMasterDataByUserId } from "./masterData/redux/masterDataThunk";
import moment from "moment";
import Footer from "../components/Footer";
import TrialExpiryAlert from "../components/TrialExpiryAlert";
import MobileContactStrip from "../components/MobileContactStrip";
import "./home.css";
import "./shared/dashboard.css";
import PartnerPopup from "../components/PartnerPopup";
import ComingSoonPopup from "../components/ComingSoonPopup";
import PaidFeaturePopup from "../components/PaidFeaturePopup";
import { getStatusAPI } from "../features/ticketing-app/redux/ticketingSlice";
import SchoolGrantForm from "../components/SchoolGrantForm";
import PartnerRequestForm from "../components/PartnershipForm";
import EmailVerifyPopup from "../components/EmailVerifyPopup";
const PLAN = {
  name: "Complete Access",
  price: "₹500",
  priceNote: "per feature, per user",
  lines: ["Choose the modules you need", "Documents & Correspondences free"],
  to: "/all-plan",
};

const GuestUserHome = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isExpired, setIsExpired] = useState(false);
  const [partnerPopup, setPartnerPopup] = useState(false);
  const [comingSoonPopup, setComingSoonPopup] = useState(false);
  const [demoPopup, setDemoPopup] = useState(false);
  const [paidFeaturePopup, setPaidFeaturePopup] = useState(false);
  const [sponsorshipPopUp, setSponsorshipPopUp] = useState(false);
  const [toast, setToast] = useState({
    visible: false,
    message: "",
    x: 0,
    y: 0,
  });
  const [partnershipPopUp, setPartnershipPopUp] = useState(false);
  const [emailVerifyOpen, setEmailVerifyOpen] = useState(false);
  const userData = userStore((state) => state.user);
  const canCreateUsers =
    Array.isArray(userData?.payments) &&
    userData.payments.some((p) => p.no_of_users > 1);
  const showEmailVerifyBanner =
    userData?.is_email === 0 &&
    Array.isArray(userData?.payments) &&
    userData.payments.length > 0;
  const userDetails = JSON.parse(localStorage.getItem("userData") || "null");
  const isMasterData = userDetails?.is_masterData == 1 ? true : false;

  const logOut = () => {
    dispatch(logout());
    navigate("/home");
  };

  // Reordered according to the handwritten layout:
  // Row 1: Master Data, Question Paper, Event Organiser, Quiz
  // Row 2: Add Teachers/Users, Time Table, Teachers Planner, STEM
  // Row 3: Academic Calendar, Documents, Pedagogy
  const allModules = [
    {
      id: 2,
      name: "Create Question Paper",
      color: "#da5252",
      path: "/createPaper",
      icon: "/images/questionpaper.png",
    },
    {
      id: 4,
      name: "Create Academic Calendar",
      color: "#d80564",
      path: "/calendarview",
      icon: "/images/3.png",
    },
    {
      id: 3,
      name: "Create Time Table",
      color: "#1c498d",
      path: "/timetable/subjects",
      icon: "/images/timetable.png",
    },
    {
      id: 7,
      name: "Olympiads & Quiz",
      color: "#f89406",
      // path: "/quizList",
      icon: "/images/quizicon.png",
    },
    {
      id: 6,
      name: "Create Documents",
      color: "#018bd6",
      path: "/myDocuments",
      icon: "/images/documents.png",
    },
    {
      id: 1,
      name: "Create Event Organiser",
      color: "#86bc28",
      path: "/showEvents",
      icon: "/images/event.png",
    },
    {
      id: 5,
      name: "Create Teachers Planner",
      color: "#d4166b",
      path: "/alltimeTable",
      icon: "/images/teacherplanner.png",
    },

    {
      id: 10,
      name: "Create Teachers/Users",
      color: "#9b1616",
      path: "/userList",
      icon: "/images/adduser.png",
      mobileHide: true,
      // openPaidPopup: true,
    },
    {
      id: 8,
      name: "STEM & Robotics",
      color: "#27ae60",
      path: "#",
      icon: "/images/stem.png",
      comingSoon: true,
      openComingSoon: true,
    },
    {
      id: 9,
      name: "Pedagogy",
      color: "#16a2b8",
      path: "#",
      icon: "/images/pedagogy.png",
      comingSoon: true,
      openComingSoon: true,
    },
    // {
    //   id: 11,
    //   name: "Become Our Partner and Earn",
    //   color: "#f5a623",
    //   emoji: "🤝",
    //   subtitle: "₹25,000/- to ₹50,000/-",
    //   noNav: true,
    //   nameFontSize: "14px",
    //   openPartnerPopup: true,
    //   partnerShipPopUp: true,
    //   alwaysAccessible: true,
    // },
    // {
    //   id: 12,
    //   name: "Apply for Grants & Sponsorships",
    //   // subtitle: "( Up to 25 Lakhs)",
    //   color: "#2bab8b",
    //   emoji: "💰",
    //   nameFontSize: "14px",
    //   noNav: true,
    //   // openPartnerPopup: true,
    //   sponsorShipPopup: true,
    //   alwaysAccessible: true,
    // },
    { id: 13, name: "Student Management", subtitle: "Admission & Fee", color: "linear-gradient(135deg, #8de94b 0%, #a0c763 100%)", icon: "/images/student-managment.png", openDemoPopup: true, alwaysAccessible: true },
    { id: 14, name: "Library Management", color: "linear-gradient(135deg, #1c498d 0%, #3a6bb5 100%)", icon: "/images/lib-managment.png", openDemoPopup: true, alwaysAccessible: true },
  ];
  const styles = {
    heroSection: {
      background:
        "linear-gradient(135deg, #1e5bb8 0%, #7c4daf 50%, #d4a574 100%)",
      padding: "30px 60px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "16px",
      flexWrap: "wrap",
      height: "280px",
      flexShrink: 0,
      boxSizing: "border-box",
    },
    heroContent: {
      maxWidth: "600px",
    },
    heroTitle: {
      color: "white",
      fontSize: "36px",
      fontWeight: "700",
      margin: "0 0 6px 0",
      lineHeight: "1.2",
    },
    heroSubtitle: {
      color: "white",
      fontSize: "18px",
      fontWeight: "400",
      margin: "0",
      opacity: "0.95",
    },
    modulesContainer: {
      padding: "8px 60px",
      backgroundColor: "#f8f9fa",
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      overflow: "hidden",
    },
    modulesGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: "10px",
      maxWidth: "1400px",
      margin: "20px 0",
      justifyItems: "stretch",
    },
    moduleCard: {
      display: "flex",
      alignItems: "center",
      padding: "0 20px",
      borderRadius: "8px",
      height: "70px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      position: "relative",
      overflow: "hidden",
    },
    moduleIconContainer: {
      width: "50px",
      height: "50px",
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      marginRight: "15px",
    },
    moduleIcon: {
      width: "30px",
      height: "30px",
      objectFit: "contain",
    },
    moduleName: {
      color: "white",
      fontSize: "18px",
      fontWeight: "600",
      flex: 1,
      textAlign: "left",
      textTransform: "capitalize",
      letterSpacing: "0.5px",
    },
  };

  const [allowedModuleIds, setAllowedModuleIds] = useState(
    allModules.map((m) => m.id),
  );

  useEffect(() => {
    let expiryDate;

    // Guest user flow:
    //  1) During trial (today < trial_period_end_time) → full access to all modules.
    //  2) After trial expiry → restrict access to modules from their first payment.
    //  3) Trial expired with no payment → block access.
    if (userData?.roles === "guest_user") {
      const trialEnd = moment(userData.trial_period_end_time).startOf("day");
      const today = moment().startOf("day");
      const trialExpired = today.isSameOrAfter(trialEnd);

      if (!trialExpired) {
        // Still inside trial — unlock everything until trialEnd
        expiryDate = trialEnd;
        setAllowedModuleIds(allModules.map((m) => m.id));
      } else if (
        Array.isArray(userData.payments) &&
        userData.payments.length > 0
      ) {
        // Trial expired — union access across every still-valid payment.
        // Each payment carries its own validity window from created_at,
        // determined by plan_type. A "complete" payment grants all modules;
        // customized/special/special2 grant only their selected_Modules.
        const validityMonthsByPlan = {
          complete: 12,
          customized: 12,
          special: 3,
          special2: 12,
        };

        const allowed = new Set();
        let latestExpiry = null;
        let hasCompletePlan = false;

        userData.payments.forEach((payment) => {
          const months = validityMonthsByPlan[payment.plan_type];
          if (months == null) return; // unknown plan_type — skip

          const paymentExpiry = moment(payment.created_at)
            .add(months, "months")
            .startOf("day");

          // Skip payments whose validity window has already closed
          if (!today.isBefore(paymentExpiry)) return;

          if (payment.plan_type === "complete") {
            hasCompletePlan = true;
          } else {
            (payment.selected_Modules || "")
              .split(",")
              .map((id) => parseInt(id.trim(), 10))
              .filter((id) => !isNaN(id))
              .forEach((id) => allowed.add(id));
          }

          if (!latestExpiry || paymentExpiry.isAfter(latestExpiry)) {
            latestExpiry = paymentExpiry;
          }
        });

        if (hasCompletePlan) {
          setAllowedModuleIds(allModules.map((m) => m.id));
          expiryDate = latestExpiry;
        } else if (allowed.size > 0) {
          setAllowedModuleIds(Array.from(allowed));
          expiryDate = latestExpiry;
        } else {
          // Every payment has expired — block access
          setAllowedModuleIds([]);
          setIsExpired(true);
          expiryDate = trialEnd;
        }
      } else {
        // Trial expired and no payment — block all modules.
        // Keep expiryDate = trialEnd so the bottom block fires the
        // "access period has been completed" alert.
        setAllowedModuleIds([]);
        setIsExpired(true);
        expiryDate = trialEnd;
      }
    }

    if (expiryDate) {
      const today = moment().startOf("day");
      const alertShown = localStorage.getItem("demoAlertShown");

      if (today.isSameOrAfter(expiryDate)) {
        setIsExpired(true);
        alert("Your access period has been completed.");
      } else if (!alertShown) {
        localStorage.setItem("demoAlertShown", "true");
      }
    }

    // if (isMasterData) {
    //   dispatch(getMasterDataByUserId(userData.id));
    // } else {
    //   navigate("/createMaster");
    // }
  }, [
    dispatch,
    userData?.id,
    userDetails?.is_masterData,
    userData,
    navigate,
    isMasterData,
  ]);

  useEffect(() => {
    if (canCreateUsers) {
      setAllowedModuleIds((prev) =>
        prev.includes(10) ? prev : [...prev, 10]
      );
    }
  }, [canCreateUsers]);

  const handleClick = (path, id, noNav) => {
    if (noNav) return;
    if (isExpired) {
      alert("Your demo period has expired.");
    } else if (!allowedModuleIds.includes(id)) {
      alert("You have no access to this module.");
    } else {
      navigate(path);
    }
  };

  const { pathname } = useLocation();

  const handleModuleClick = async (mod) => {
    console.log("mod details", JSON.stringify(mod));
    console.log(JSON.stringify(userData));

    // Paid feature popup
    if (mod.openPaidPopup) {
      setPaidFeaturePopup(true);
      return;
    }

    // Schedule-a-demo popup
    if (mod.openDemoPopup) {
      setDemoPopup(true);
      return;
    }

    // Coming soon popup
    if (mod.openComingSoon) {
      setComingSoonPopup(true);
      return;
    }

    // Apply for Grants & Sponsorships (SPECIAL CASE)
    if (
      mod.sponsorShipPopup &&
      mod.id === 12 &&
      mod.name === "Apply for Grants & Sponsorships"
    ) {
      if (!userData?.admin_id) return;

      const response = await dispatch(getStatusAPI(userData.admin_id));

      if (response?.type === "ticketing/getStatusAPI/fulfilled") {
        if (!response.payload?.grants_sponsorships_filled) {
          setSponsorshipPopUp(true);
        } else {
          alert("Grants & Sponsorships form is already filled");
        }
      }
      return;
    }
    if (
      mod.partnerShipPopUp &&
      mod.id === 11 &&
      mod.name === "Become Our Partner and Earn"
    ) {
      if (!userData?.admin_id) return;

      const response = await dispatch(getStatusAPI(userData.admin_id));

      if (response?.type === "ticketing/getStatusAPI/fulfilled") {
        if (!response.payload?.partnership_filled) {
          setPartnershipPopUp(true);
        } else {
          alert("Grants & Sponsorships form is already filled");
        }
      }
      return;
    }

    // Partner popup
    if (mod.openPartnerPopup) {
      setPartnerPopup(true);
      return;
    }

    // Default navigation
    handleClick(mod.path, mod.id, mod.noNav);
  };
  return (
    <Suspense fallback={<div>Loading...</div>}>
      {/* <TrialExpiryAlert user={userData} /> */}

      <div
        className="main-container-responsive"
        style={{
          minHeight: "100vh",
          maxHeight: "100vh",
          backgroundColor: "#f8f9fa",
          overflow: "hidden",
        }}
      >
        {toast.visible && (
          <div
            style={{
              position: "fixed",
              top: toast.y - 40,
              left: toast.x,
              transform: "translateX(-50%)",
              backgroundColor: "#333",
              color: "white",
              padding: "8px 16px",
              borderRadius: "6px",
              zIndex: 9999,
              fontSize: "14px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              whiteSpace: "nowrap",
            }}
          >
            {toast.message}
          </div>
        )}
        {showEmailVerifyBanner && (
          <div
            onClick={() => setEmailVerifyOpen(true)}
            style={{
              position: "fixed",
              top: "140px",
              right: "20px",
              zIndex: 1100,
              minWidth: "280px",
              maxWidth: "340px",
              background:
                "linear-gradient(135deg, #ffffff 0%, #fffbeb 55%, #fde68a 100%)",
              borderRadius: "12px",
              border: "1px solid #fcd34d",
              boxShadow:
                "0 10px 24px rgba(245, 158, 11, 0.18), 0 2px 6px rgba(15, 23, 42, 0.06)",
              padding: "14px 16px",
              display: "flex",
              alignItems: "flex-start",
              gap: "12px",
              cursor: "pointer",
              fontFamily:
                'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
            }}
          >
            <div
              style={{
                width: "34px",
                height: "34px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #f59e0b, #ef4444)",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 800,
                flexShrink: 0,
                fontSize: "18px",
                boxShadow: "0 4px 10px rgba(239, 68, 68, 0.35)",
              }}
            >
              !
            </div>
            <div style={{ flex: 1, lineHeight: 1.4 }}>
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: 700,
                  color: "#92400e",
                  marginBottom: "3px",
                }}
              >
                Verify your email
              </div>
              <div style={{ fontSize: "12.5px", color: "#78350f" }}>
                Secure your account.{" "}
                <span
                  style={{
                    color: "#1d4ed8",
                    fontWeight: 700,
                    textDecoration: "underline",
                  }}
                >
                  Verify now
                </span>
              </div>
            </div>
          </div>
        )}
        {/* Navbar */}
        <MobileContactStrip />
        <div
          className="top_nav navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top"
          style={{ zIndex: 9, top: "30px" }}
        >
          <div
            className="container-fluid d-flex justify-content-between align-items-center"
            style={{ position: "relative" }}
          >
            <div>
              <img
                src="/images/docmasterLogo.png"
                alt="Logo"
                style={{ width: "180px", marginLeft: "20px" }}
              />
            </div>
            <div
              className="d-none d-lg-flex align-items-center gap-3"
              style={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              <a
                href="https://wa.me/919289440049?text=Hi%2C%20I%20want%20to%20know%20more%20about%20DocMaster%20services."
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "#25D366",
                  fontWeight: "600",
                  fontSize: "16px",
                  textDecoration: "none",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#25D366"
                  viewBox="0 0 24 24"
                >
                  <path d="M20.52 3.48A11.8 11.8 0 0 0 12.05 0C5.5 0 .19 5.31.19 11.86c0 2.09.55 4.13 1.6 5.92L0 24l6.39-1.67a11.83 11.83 0 0 0 5.66 1.45h.01c6.55 0 11.86-5.31 11.86-11.86 0-3.17-1.23-6.15-3.4-8.44zM12.06 21.7a9.8 9.8 0 0 1-5-1.38l-.36-.21-3.79 1 1.01-3.7-.23-.38a9.8 9.8 0 1 1 8.37 4.67zm5.44-7.35c-.3-.15-1.78-.88-2.06-.98-.28-.1-.48-.15-.68.15-.2.3-.78.98-.96 1.18-.18.2-.35.23-.65.08-.3-.15-1.28-.47-2.43-1.5-.9-.8-1.5-1.78-1.68-2.08-.18-.3-.02-.46.13-.6.14-.14.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.08-.15-.68-1.63-.94-2.24-.25-.6-.5-.52-.68-.53h-.58c-.2 0-.53.08-.8.38-.28.3-1.05 1.03-1.05 2.5 0 1.48 1.08 2.9 1.23 3.1.15.2 2.12 3.24 5.14 4.54.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.78-.73 2.03-1.44.25-.7.25-1.3.18-1.44-.08-.15-.28-.23-.58-.38z" />
                </svg>
                9289 44 00 49
              </a>
              <span style={{ color: "#ccc" }}>|</span>
              <a
                href="tel:+919289440049"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "#555",
                  fontWeight: "600",
                  fontSize: "16px",
                  textDecoration: "none",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  fill="#555"
                  viewBox="0 0 24 24"
                >
                  <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" />
                </svg>
                9289 44 00 49
              </a>
            </div>
            <div className="d-flex align-items-center gap-3">
              <div className="d-flex align-items-center justify-content-end gap-3">
                {userData?.roles === "guest_user" && (
                  <ul className="navbar-nav d-flex flex-row gap-3 mb-0">
                    <li
                      className={`nav-item ${
                        pathname === "/createMaster" ? "active" : ""
                      }`}
                    >
                      <Link
                        to="/createMaster"
                        className="nav-link d-flex flex-column align-items-center"
                      >
                        <i className="fa fa-database"></i> Master Data
                      </Link>
                    </li>
                  </ul>
                )}
                {/* <ul className="navbar-nav ps-4 w-100 d-flex gap-3 justify-content-start flex-row">
                  <li
                    className={`nav-item ${
                      ["/createUser", "/userList"].includes(pathname)
                        ? "active"
                        : ""
                    }`}
                  >
                    <Link
                      to="/userList"
                      className="nav-link"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <i className="fa fa-users"></i> Users
                    </Link>
                  </li>
                  <li
                    className={`nav-item ${
                      ["/createQuiz", "/quizList"].includes(pathname)
                        ? "active"
                        : ""
                    }`}
                  >
                    <Link
                      to="/quizList"
                      className="nav-link"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <i className="fa fa-question-circle"></i> Quiz
                    </Link>
                  </li>
                  <li
                    className={`nav-item ${
                      ["/createMaster"].includes(pathname) ? "active" : ""
                    }`}
                  >
                    <Link
                      to="/createMaster"
                      className="nav-link"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <i className="fa fa-calendar"></i> Master Data
                    </Link>
                  </li>
                </ul> */}
                <div className="dropdown me-3 navbar-dropdown">
                  <button
                    className="btn btn-light dropdown-toggle d-flex align-items-center"
                    type="button"
                    id="userDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa fa-user me-2"></i>
                    <span className="user-name-text">{userData.name}</span>
                  </button>
                  <ul
                    className="dropdown-menu dropdown-menu-end"
                    aria-labelledby="userDropdown"
                  >
                    <li>
                      <Link to="/profile" className="dropdown-item">
                        Profile
                      </Link>
                    </li>
                    <li>
                      <span className="dropdown-item" onClick={logOut}>
                        <i className="fa fa-sign-out me-2"></i> Log Out
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hero Section */}
        <div className="hero-section-responsive" style={styles.heroSection}>
          <div className="hero-content-responsive" style={styles.heroContent}>
            <h1 className="hero-title-responsive" style={styles.heroTitle}>
              {userData.school_name || ""}
            </h1>
          </div>
          <div className="dw-plan-card">
            <p className="dw-plan-label">Your plan</p>
            <p className="dw-plan-name">{PLAN.name}</p>
            <div className="dw-plan-price">
              {PLAN.price}
              {PLAN.priceNote && <small>{PLAN.priceNote}</small>}
            </div>
            {PLAN.lines.map((line) => (
              <p key={line} className="dw-plan-note">
                {line}
              </p>
            ))}
            <Link to={PLAN.to} className="dw-plan-link">
              View plans
            </Link>
          </div>
        </div>

        {/* Modules Grid */}
        <div
          className="modules-container-responsive"
          style={styles.modulesContainer}
        >
          <div className="modules-grid-responsive" style={styles.modulesGrid}>
            {allModules.map((mod) => {
              const isAllowed =
                mod.alwaysAccessible || allowedModuleIds.includes(mod.id);
              return (
                <div
                  key={mod.id}
                  className={`home-module-card module-card-responsive${mod.mobileHide ? " hide-on-mobile" : ""}`}
                  style={{
                    ...styles.moduleCard,
                    background: mod.color,
                    cursor: isAllowed ? "pointer" : "not-allowed",
                    opacity: isAllowed ? 1 : 0.7,
                    position: "relative",
                    ...(mod.gridColumn && { gridColumn: mod.gridColumn }),
                  }}
                  // onClick={() =>
                  //   mod.openPaidPopup
                  //     ? setPaidFeaturePopup(true)
                  //     : mod.openPartnerPopup
                  //       ? setPartnerPopup(true)
                  //       : mod.openComingSoon
                  //         ? setComingSoonPopup(true)
                  //         : handleClick(mod.path, mod.id, mod.noNav)
                  // }
                  onClick={() => isAllowed && handleModuleClick(mod)}
                  onMouseEnter={(e) => {
                    if (!isAllowed) {
                      const rect = e.currentTarget.getBoundingClientRect();
                      setToast({
                        visible: true,
                        message: "Upgrade your plan to use this module",
                        x: rect.left + rect.width / 2,
                        y: rect.top,
                      });
                    }
                  }}
                  onMouseLeave={() =>
                    setToast({ visible: false, message: "", x: 0, y: 0 })
                  }
                >
                  <div
                    className="module-icon-container-responsive"
                    style={styles.moduleIconContainer}
                  >
                    {mod.emoji ? (
                      <span style={{ fontSize: "28px" }}>{mod.emoji}</span>
                    ) : (
                      <img
                        className="module-icon-responsive"
                        src={mod.icon}
                        alt={mod.name}
                        style={styles.moduleIcon}
                        onError={(e) =>
                          (e.currentTarget.style.display = "none")
                        }
                      />
                    )}
                  </div>
                  <span
                    className="module-name-responsive"
                    style={{
                      ...styles.moduleName,
                      ...(mod.nameFontSize && { fontSize: mod.nameFontSize }),
                    }}
                  >
                    {mod.name}
                    {mod.subtitle && (
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          opacity: 0.9,
                        }}
                      >
                        {mod.subtitle}
                      </div>
                    )}
                    {mod.comingSoon && (
                      <div className="corner-ribbon">
                        <div className="ribbon-bg">
                          <span className="ribbon-text">
                            COMING
                            <br />
                            SOON
                          </span>
                        </div>
                      </div>
                    )}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        <Footer />
        <PartnerPopup
          isOpen={partnerPopup}
          onClose={() => setPartnerPopup(false)}
        />
        <SchoolGrantForm
          isOpen={sponsorshipPopUp}
          onClose={() => setSponsorshipPopUp(false)}
        />
        <ComingSoonPopup
          isOpen={comingSoonPopup}
          onClose={() => setComingSoonPopup(false)}
        />
        <ComingSoonPopup
          isOpen={demoPopup}
          onClose={() => setDemoPopup(false)}
          message="To Schedule a Demo / Get more details contact"
        />
        <PaidFeaturePopup
          isOpen={paidFeaturePopup}
          onClose={() => setPaidFeaturePopup(false)}
        />
        <PartnerRequestForm
          isOpen={partnershipPopUp}
          onClose={() => setPartnershipPopUp(false)}
        />
        <EmailVerifyPopup
          isOpen={emailVerifyOpen}
          onClose={() => setEmailVerifyOpen(false)}
          defaultEmail={userData?.email || ""}
          id={userData?.admin_id}
        />
      </div>
    </Suspense>
  );
};

export default GuestUserHome;
